import React, { useEffect, useRef, useState } from 'react'
import * as yup from 'yup';

import { Input, Tag, Tooltip } from 'antd';
import { Col, Icon, Row } from '@digital/ui';

import './styles.css';
import { Notifiable, Notifications } from '@app/types/core.types';
import { isObjNotEmpty } from '@app/helpers/objHelper';

interface ITagComponentProps {
    buttonText: string;
    onChange: (value: string[]) => void;
    sizeTextTag?: number;
    validate?: (value: string[]) => Notifiable;
    isValidateEmail?: boolean;
}

export const TagComponent = ({
    buttonText,
    onChange,
    sizeTextTag = 30,
    validate,
    isValidateEmail = false,
}: ITagComponentProps) => {

    const [tags, setTags] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState('');
    const [editInputIndex, setEditInputIndex] = useState(-1);
    const [editInputValue, setEditInputValue] = useState('');

    const [inputVisible, setInputVisible] = useState(false);
    const [errors, setErrors] = useState<Notifications[]>([]);

    const inputRef = useRef<any>(null);
    const editInputRef = useRef<any>(null);

    let schemaEmailValidate = yup.object().shape({
        array: yup.array().of(yup.string().email()),
    });

    useEffect(() => {
        onChange && onChange(tags);
    }, [tags])


    const handleClose = (removedTag: string) => {
        const newTags = tags.filter(tag => tag !== removedTag);
        setTags(newTags);
    };

    const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditInputValue(e.target.value);
    };

    const handleEditInputConfirm = () => {
        const newTags = [...tags];
        newTags[editInputIndex] = editInputValue;
        setTags(newTags);
        setEditInputIndex(-1);
        setInputValue('');
    };

    const showInput = () => {
        inputRef.current && inputRef.current.focus({
            cursor: 'start',
        });
        setInputVisible(true);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const handleInputConfirm = () => {
        setErrors([]);

        if (inputValue && tags.indexOf(inputValue) === -1) {
            let newTags = [...tags];
            inputValue.split(',').forEach((item: string) => {
                newTags.push(item);
            })

            if (isValidateEmail) {
                schemaEmailValidate
                    .isValid({
                        array: newTags,
                    })
                    .then(function (valid) {
                        if (valid) {
                            setTags(newTags);
                            setInputValue('');
                            setInputVisible(false);
                        } else {
                            setErrors([{ message: 'Campo inválido', property: 'error' }] as Notifications[]);
                        }
                    });
            }

            if (isObjNotEmpty(validate)) {
                const notifiable: Notifiable = validate && validate(newTags) || { valid: true };
                if (notifiable.valid) {
                    setTags(newTags);
                    setInputVisible(false);
                    setInputValue('');
                } else {
                    setErrors(notifiable.notifications || []);
                }
                return;
            }
        }
    };

    return (
        <Row align='middle' type="flex">
            {tags.map((tag, index) => {
                if (editInputIndex === index) {
                    return (
                        <Input
                            ref={editInputRef}
                            key={tag}
                            size="small"
                            className="tag-input"
                            value={editInputValue}
                            onChange={handleEditInputChange}
                            onBlur={handleEditInputConfirm}
                            onPressEnter={handleEditInputConfirm}
                        />
                    );
                }

                const isLongTag: boolean = tag.length > sizeTextTag;

                const tagElem = (
                    <Tag
                        className="edit-tag"
                        key={tag}
                        closable
                        onClose={() => handleClose(tag)}
                    >
                        <span
                            onDoubleClick={e => {
                                if (index !== 0) {
                                    setEditInputIndex(index);
                                    setEditInputValue(tag);
                                    e.preventDefault();
                                }
                            }}
                        >
                            {isLongTag ? `${tag.slice(0, sizeTextTag)}...` : tag}
                        </span>
                    </Tag>
                );
                return isLongTag ? (
                    <Tooltip title={tag} key={tag}>
                        {tagElem}
                    </Tooltip>
                ) : (
                    tagElem
                );
            })}

            {inputVisible && (
                <Col span={6}>
                    <Input
                        ref={inputRef}
                        type="text"
                        size="small"
                        className="tag-input"
                        value={inputValue}
                        onChange={handleInputChange}
                        onBlur={handleInputConfirm}
                        onPressEnter={handleInputConfirm}
                    />
                </Col>
            )}

            {!inputVisible && (
                <Tag className="site-tag-plus" onClick={showInput}>
                    <Icon name="commons-plus" style={{ fontSize: 16 }} />
                    <span style={{ marginLeft: 8 }}>{buttonText || "Nova tag"}</span>
                </Tag>
            )}

            {errors.map((error, index) => (
                <Col key={index} span={24}>
                    <span className="txt-danger">{error.message}</span>
                </Col>
            ))}
        </Row>
    )
}
